// @flow

import { createAction } from 'redux-actions';
import { UPDATE_DOCUMENT_TITLE } from 'esm-web-pro/redux/documentTitle/constants';

const updateDocumentTitle = createAction(
    UPDATE_DOCUMENT_TITLE, (title: string) => (title),
);

export default updateDocumentTitle;
